import Swiper, { Navigation, EffectFade } from 'swiper';
// configure Swiper to use modules
Swiper.use([Navigation, EffectFade]);

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

export {Swiper}
